import template from './trip-item-ferry.html';

const DIRECTIVE_NAME = TripItemFerry.DIRECTIVE_NAME = 'ktTripItemFerry';
export default function TripItemFerry() {
    return {
        restrict: 'A',
        template,
        scope: {
            ferry: `=${DIRECTIVE_NAME}`,
            isCheckout: `=${DIRECTIVE_NAME}IsCheckout`,
        },
        bindToController: true,
        controller: TripItemFerryController,
        controllerAs: '$ctrl',
        link: function($scope, $elem, $attrs, $ctrl) {
            $ctrl.$onInit();
        },
    };
}

export function TripItemFerryController(
    userService,
    tripItemFerryService
) {
    'ngInject';

    const vm = this;

    Object.assign(vm, {
        $onInit,
    });

    function $onInit() {
        vm.rs = userService.getRegionalSettings();
        vm.fromToRoute = tripItemFerryService.getFromToRoute(vm.ferry);
        vm.departureDate = tripItemFerryService.getDepartureDate(vm.ferry);
        vm.arrivalDate = tripItemFerryService.getArrivalDate(vm.ferry);
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/trip/trip-item-ferry/trip-item-ferry-component.js